import { EditorState } from "@codemirror/state";
import { EditorView } from "@codemirror/view";
import { debuggerSetup } from "./editorSetup.js";
import * as highlightPatterns from "./highlightPatterns.js";

export class CulpritPatternHighlighting extends HTMLElement {
  #template: HTMLTemplateElement;
  #shadowRoot: ShadowRoot;
  editor: EditorView | null = null;
  constructor() {
    super();
    this.#template = document.querySelector("#culprit-pattern-highlighting")!;
    this.#shadowRoot = this.attachShadow({ mode: "open" });
    this.#shadowRoot.appendChild(this.#template.content.cloneNode(true));
  }

  connectedCallback() {
    const pre = this.#shadowRoot.querySelector("pre");
    if (pre instanceof HTMLPreElement) {
      const container = document.createElement("div");
      container.classList.add("code-block");
      const failedPatterns = highlightPatterns.parse(
        this.dataset.failedPatterns ?? ""
      );
      const matchedPatterns = highlightPatterns.parse(
        this.dataset.matchedPatterns ?? ""
      );
      const unusedPatterns = highlightPatterns.parse(
        this.dataset.unusedPatterns ?? ""
      );
      const breakpointLine = this.dataset.breakpointLine
        ? Number(this.dataset.breakpointLine)
        : NaN;
      pre.replaceWith(container);
      this.editor = new EditorView({
        parent: container,
        state: EditorState.create({
          doc: pre.textContent ?? "",
          extensions: [
            debuggerSetup,
            EditorView.editable.of(false),
            highlightPatterns.matchedPatternsFacet.of(matchedPatterns),
            highlightPatterns.failedPatternsFacet.of(failedPatterns),
            highlightPatterns.unusedPatternsFacet.of(unusedPatterns),
            highlightPatterns.breakpointLineFacet.of(breakpointLine),
            highlightPatterns.viewPlugin,
          ],
        }),
      });
      // this.#shadowRoot.appendChild(
      //   CulpritPatternHighlighting.editorStyles!.cloneNode(true)
      // );
    }
  }

  // attributeChangedCallback(name: string, _oldValue: string, newValue: string) {
  //   const ranges = highlightPatterns.parse(newValue);
  //   switch (name) {
  //     case "data-failed-patterns":
  //     case "data-matched-patterns":
  //     case "data-unused-patterns":
  //     default:
  //       return;
  //   }
  // }

  static observedAttributes = [
    "data-failed-patterns",
    "data-matched-patterns",
    "data-unused-patterns",
    "data-breakpoint-line",
  ];
  static editorStyles = document.getElementById("editor-styles");
}

customElements.define(
  "culprit-pattern-highlighting",
  CulpritPatternHighlighting
);
